import React from 'react';
import Navbar from './components/Navbar';
import ShowAllProducts from './components/ShowAllProducts';
import ShowOneProduct from './components/ShowOneProduct';
import ProductDetail from './components/ProductDetail';
import AddNewProduct from './components/AddNewProduct';
import DeleteOneProduct from './components/DeleteOneProduct';
import UpdateProductById from './components/UpdateProductById';
import Cart from './components/Cart';
import Checkout from './components/Checkout';
import CheckoutSuccess from './components/CheckoutSuccess';
import AdminGate from './components/AdminGate';
import { CartProvider } from './context/CartContext';
import { AdminProvider } from './context/AdminContext';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

function GameRedirect() {
  React.useEffect(() => {
    window.location.href = '/game/';
  }, []);
  return <div style={{ padding: '2rem', textAlign: 'center' }}>Loading game...</div>;
}

function App() {
  return (
    <AdminProvider>
      <CartProvider>
        <Router>
          <div className="App">
            <Navbar />
            <Routes>
              <Route index element={<GameRedirect />} />
              <Route path="/show-all-products" element={<ShowAllProducts />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/show-one-product" element={<AdminGate><ShowOneProduct /></AdminGate>} />
              <Route path="/add-new-product" element={<AdminGate><AddNewProduct /></AdminGate>} />
              <Route path="/delete-one-product" element={<AdminGate><DeleteOneProduct /></AdminGate>} />
              <Route path="/update-product" element={<AdminGate><UpdateProductById /></AdminGate>} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/checkout/success" element={<CheckoutSuccess />} />
            </Routes>
          </div>
        </Router>
      </CartProvider>
    </AdminProvider>
  );
}

export default App;


